/**
 * External dependencies
 */
import React from "react";
import { Box, Text } from "@towersystems/towersystems-design-system";
import classnames from "classnames";
import noop from "lodash";

/**
 * Internal dependencies
 */

const Item = ({ value, selected, onClick = noop, title, description }) => {
  const handleClick = () => {
    onClick(value);
  };

  const classes = classnames("report-builder__data-type-item", {
    "is-selected": selected,
  });

  return (
    <Box
      component="button"
      onClick={handleClick}
      className={classes}
      boxShadow="borderStandard"
      padding="large"
      align="left"
      display="flex"
      flexDirection="column"
      justifyContent="flexStart"
    >
      <Box marginBottom="medium">
        <Text weight="medium" marginBottom="xlarge">
          {title}
        </Text>
      </Box>
      <Box marginBottom="medium">
        <Text size="small">{description}</Text>
      </Box>
    </Box>
  );
};

export default Item;
